if (!customElements.get('tb-clinical-carousel')) {
  customElements.define('tb-clinical-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.track = this.querySelector('[data-track]');
      this.previous = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      if (!this.track || !this.previous || !this.next) return;
      const update = () => {
        this.previous.disabled = this.track.scrollLeft < 3;
        this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 3;
      };
      const move = direction => {
        const card = this.track.firstElementChild;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        const distance = (card?.getBoundingClientRect().width || this.track.clientWidth) + gap;
        this.track.scrollBy({left:distance * direction,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      };
      this.previous.addEventListener('click',()=>move(-1),options);
      this.next.addEventListener('click',()=>move(1),options);
      this.track.addEventListener('scroll',update,{...options,passive:true});
      this.track.addEventListener('keydown',event=>{
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); move(event.key === 'ArrowRight'?1:-1);
        }
      },options);
      this.resize = new ResizeObserver(update);
      this.resize.observe(this.track);
      document.addEventListener('shopify:block:select',event=>{
        if (this.track.contains(event.target)) {
          event.target.scrollIntoView({behavior:'instant',block:'nearest',inline:'start'});
        }
      },options);
      update();
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
  });
}
document.addEventListener('shopify:block:select',event=>{
  const detail=event.target.closest('.tb-c-tech-item,.tb-c-faq-item');
  if (detail) detail.open=true;
});
